import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_user = _resolveComponent("app-user")!

  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.time)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, " Posts imported up until " + _toDisplayString(_ctx.$filters.datetime(_ctx.time)), 1))
      : (_openBlock(), _createBlock(_component_app_user, { key: 1 }, {
          default: _withCtx(({ isCustomer }) => [
            isCustomer
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "No posts have been imported"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
  ]))
}